module.exports = __webpack_public_path__ + "img/code-24px.4c326846.svg";